<template>
  <el-container class="register" v-loading="loading">
    <common-aside></common-aside>
    <el-main class="content">
      <div class="login-banner">
        <img src="../../assets/img/thank-nav-banner.png" alt="Christmas Day" />
      </div>
      <section class="header" :class="{ scroll: hasScroll === true }">
        <div class="logo">
          <a href="https://asogrow.net/" target="_blank">
            <img src="../../assets/img/logo.svg" alt="LOGO" class="logo-img" />
          </a>
        </div>
        <div class="rightWrap">
          <div class="langBtn" @click="changeLang('register')">EN/CN</div>
          <div class="login-link overlay-btn" @click="goLogin">
            <span>{{ $t('messages.login.loginText') }}</span>
          </div>
          <div class="banner-logo">
            <img src="../../assets/img/thank-login-logo.png" alt="LOGO" class="logo-img" />
          </div>
        </div>
      </section>
      <section class="main">
        <el-scrollbar style="height: 100%;" ref="scrollbar" v-if="page_level === 1">
          <el-form
            :model="regist"
            ref="registerForm"
            :rules="rules"
            v-if="page_level === 1"
            status-icon
            class="regist-form"
          >
            <div class="signup-title">
              <h1>{{ $t('messages.register.regTip') }}</h1>
              <div class="signup-title-btn" @click="goLogin">{{ $t('messages.login.loginText') }}</div>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick" class="head-tabs">
              <el-tab-pane :label="$t('messages.login.email')" name="email">
                <template v-if="activeName === 'email'">
                  <el-form-item prop="email">
                    <el-input
                      v-model="regist.email"
                      type="email"
                      :placeholder="$t('messages.register.emailInput')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      name="password"
                      type="password"
                      v-model="regist.password"
                      :placeholder="$t('messages.register.passInput')"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="confirm_password">
                    <el-input
                      name="password"
                      type="password"
                      v-model="regist.confirm_password"
                      :placeholder="$t('messages.register.comPassInput')"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-tab-pane>
              <el-tab-pane :label="$t('messages.login.phone')" name="phone">
                <template v-if="activeName === 'phone'">
                  <el-form-item prop="phone" class="application-number application-number2">
                    <el-input
                      v-model="regist.phone"
                      :placeholder="$t('messages.register.phoneTip')"
                    >
                      <el-select
                        v-model="area"
                        slot="prepend"
                        size="medium"
                        filterable
                        popper-class="app-select area-code-select"
                        :placeholder="$t('messages.other.other54')"
                      >
                        <el-option
                          v-for="(item, i) in areaCodeList"
                          :key="i"
                          :label="item.code + '     ' + item.country"
                          :value="item.country"
                        >
                          <p class="option-p">
                            <span>{{ item.code }}</span>
                            <span>{{ item.country }}</span>
                          </p>
                        </el-option>
                      </el-select>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="code" class="captcha captcha-send-code">
                    <el-input
                      v-model="regist.code"
                      name="code"
                      :placeholder="$t('messages.register.code')"
                    >
                      <template slot="append">
                        <div class="send-code" @click="sendCode" id="send-code">
                          <p id="send-tit">{{ $t('messages.login.send') }}</p>
                          <p id="sending">
                            <span style="margin-right: 2px;">{{ $t('messages.login.resend') }}</span>
                            <span id="countdown-text" style="width: 26px;">(60)</span>
                          </p>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </template>
              </el-tab-pane>
            </el-tabs>

            <el-form-item prop="user_agreement">
              <div style="color: #909399;font-size: 12px;">
                <span>&nbsp;{{ $t('messages.register.tip2') }}&nbsp;</span>
                <a href="/privacy" target="_blank" style="font-size: 12px;">
                  {{ $t('messages.register.tip22') }}
                </a>
                <span>&nbsp;{{ $t('messages.register.tip222') }}&nbsp;</span>
                <a href="/terms" target="_blank" style="font-size: 12px;">
                  {{ $t('messages.register.tip2222') }}
                </a>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button class="sign-up-btn overlay-btn" type="primary" @click="signUp">
                {{ $t('messages.register.btn') }}
              </el-button>
            </el-form-item>
            <div style="padding-bottom: 12px;margin-bottom: 12px;">
              <google-btn
                :key="$i18n.locale"
                :showOr="false"
                :type="2"
                :query="query"
                :align="'flex-start'"
              ></google-btn>
            </div>
            <!-- 移动端切换语言按钮 -->
            <div class="lang-switch-wrap">
              <div class="lang-switch" id="lang-switch" @click="changeLang('register')">
                <div :class="{ 'lang-icon': true, langActive: this.$i18n.locale === 'en' }">EN</div>
                <div :class="{ 'lang-icon': true, langActive: this.$i18n.locale === 'zh' }">CN</div>
              </div>
            </div>
            <div class="copyright">
              <span>© 2022 有米科技股份有限公司 版权所有</span>
              <span @click="handleDomain">粤ICP备11022409号</span>
              <span @click="handleGo">粤公网安备44011302003751号</span>
            </div>
          </el-form>
        </el-scrollbar>
      </section>
    </el-main>
    <!-- <contact-box></contact-box> -->
    <el-dialog
      :visible.sync="codeFailDialog"
      width="560px"
      :close-on-click-modal="false"
      :title="$t('messages.createCampaign.create156')"
    >
      <div class="noAppDialog">
        <p>{{ $t('messages.tipError.sendErr1') }}</p>
        <p>{{ $t('messages.tipError.sendErr2') }}</p>
        <p v-if="codeFailTip !== 'Not OK'">{{ $t('messages.tipError.sendErr3') }}:{{ codeFailTip }}</p>
        <div class="btns">
          <el-button class="btn1" @click="contactUS">{{ $t('messages.tipError.sendErr4') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
import { getCookie, removeCookie } from 'tiny-cookie'
import commonAside from '@/components/commonAside'
import googleBtn from '@/components/googleBtn'
import loginAndRegisterMixin from '@/mixins/loginAndRegisterMixin'
let countdownInterval;
export default {
  components: { commonAside, googleBtn },
  mixins:[ loginAndRegisterMixin ],
  data() {
    return {
      gutter: 32,
      page_level: 1,
      hasScroll: false,
      regist: {
        username: '',
        email: '',
        password: '',
        confirm_password: '',
        contact_type: 3,
        product_url: '',
        phone: '',
        code: '',
      },
      area: '',
      user_agreement: ['1', '2'],
      rules: {},
      loading: false,
      applications: [
        { label: 'WhatsApp', value: 3, src: require('../../assets/img/WhatsApp.png') },
        { label: 'Teams', value: 1, src: require('../../assets/img/Teams.png') },
        { label: 'Telegram', value: 5, src: require('../../assets/img/Telegram.png') },
        { label: 'WeChat', value: 7, src: require('../../assets/img/WeChat.png') },
        { label: 'Phone', value: 8, src: require('../../assets/img/Phone-b.png') },
      ],
      source: 'Official',
      pl: '',
      query: 's=Official',
      changeing: false,
      activeName: 'email',
      areaCodeList: [],
      sending: false,
      codeFailDialog: false,
      intervalId: null,
      maxExecutions: 60,
      executionCount: 0,
      codeFailTip:'',
      lunxunPhone: '',
    }
  },
  created() {
    this.$nextTick(() => {
      this.changeContactType(3)
    })
    let s = this.$route.query.s
    let product_url = this.$route.query.pl
    let email = this.$route.query.email
    if (email) {
      this.regist.email = email
    }
    if (product_url === undefined) {
      product_url = ''
    } else {
      this.regist.product_url = product_url
      this.pl = product_url
    }
    if (s === undefined) {
      // 自动处理url
      this.regist.register_source = 'Official'
      this.source = 'Official'
    } else {
      this.regist.register_source = s
      this.source = s
    }
    this.query = `s=${this.source}`
    if (this.pl) {
      this.query = this.query + '&pl=' + this.pl
    }
    this.$forceUpdate()
    this.setFormRules()
    this.getAreaCodeList()
  },
  mounted() {
    this.headerScroll()
  },
  beforeDestroy() {
    // 清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        let s = val.query.s
        let product_url = val.query.pl
        if (product_url === undefined) {
          product_url = ''
        }
        this.regist.product_url = product_url
        if (s === undefined) {
          // 自动处理url
          // window.location.href = val.fullPath + '?s=Official'
          this.regist.register_source = 'Official'
        } else {
          this.regist.register_source = s
        }
      },
      // 深度观察监听
      immediate: true,
    },
    '$i18n.locale': function() {
      this.setFormRules()
      this.$nextTick(() => {
        if (this.$refs['registerForm']) {
          this.$refs['registerForm'].fields.forEach(item => {
            item.clearValidate()
          })
        }
      })
    },
  },
  computed: {
    areaPhone() {
      let str = ''
      let phone = this.regist.phone
      let newPhone = ''
      let country = this.areaCodeList.filter(row => row.country === this.area)
      if (country.length > 0) {
        str = country[0].code
        newPhone = str + phone
      }
      return newPhone
    },
  },
  methods: {
    getAreaCodeList() {
      this.$http
        .get('/api/accounts/get_phone_area_code/')
        .then(data => {
          this.areaCodeList = data.data
          this.area = data.country
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    handleClick(tab, event) {},
    // 定义要执行的任务函数
    executeTask() {
      // console.log("Task executed at " + new Date().toLocaleTimeString());
      // 增加执行次数
      this.executionCount++
      // 检查是否达到了最大执行次数
      if (this.executionCount >= this.maxExecutions) {
        // 清除定时器
        clearInterval(this.intervalId)
        // console.log("Timer stopped at " + new Date().toLocaleTimeString());
      } else {
        let params = {
          phone: this.lunxunPhone,
          typ: 'register',
          lang: this.$i18n.locale,
        }
        this.$http
          .post('/api/accounts/send-sms/result/', params)
          .then(res => {
            if (res.data.send_status === 1) {
              clearInterval(this.intervalId)
            } else if (res.data.send_status !== 0) {
              this.codeFailDialog = true
              this.codeFailTip = res.data.msg
              clearInterval(this.intervalId)
            }
          })
          .catch(error => {
              if (error.c === -1301) {
                this.notifyOpen('Error', this.$t('messages.register.codeAgain'), 'error')
              }else if (error.c === -1404) {
                this.notifyOpen('Error', this.$t('messages.register.codeAgain2'), 'error')
              }else if (error.c === -1405) {
                this.notifyOpen('Error', this.$t('messages.tipError.phoneCodeErr'), 'error')
              }else {
                this.notifyOpen('Error', error.m || this.$t('messages.tipError.timeout'), 'error')
              }
          })
      }
    },
    contactUS() {
      this.codeFailDialog = false
      this.$EventBus.$emit('showContact')
      this.OpenTawkChat()
    },
    handleCountdown2() {
      // 设置定时器，每两秒执行一次 executeTask 函数
      this.intervalId = setInterval(this.executeTask, 2000)
    },
    handleCountdown() {
      // this.sending = true;
      // 初始化倒计时时间（秒）
      let timeLeft = 60
      // 获取显示倒计时的元素
      let dom = document.getElementById('send-tit')
      let dom2 = document.getElementById('sending')
      let dom3 = document.getElementById('countdown-text')
      let dom4 = document.getElementById('send-code')
      this.sending = true
      // 创建一个每秒更新一次倒计时的函数
      countdownInterval = setInterval(() => {
        // 更新倒计时显示
        dom.style.display = 'none'
        dom2.style.display = 'block'
        dom4.style.background = '#909399'
        dom3.textContent = `(${timeLeft})`
        // 检查倒计时是否结束
        if (timeLeft < 0) {
          // 清除定时器
          clearInterval(countdownInterval)
          dom.style.display = 'block'
          dom2.style.display = 'none'
          dom4.style.background = '#E9077C'
          this.sending = false
        } else {
          // 减少倒计时时间
          timeLeft--
        }
      }, 1000) // 1000毫秒 = 1秒
    },
    sendCode() {
      if (!this.sending) {
        this.$refs.registerForm.validateField('phone', error => {
          if (!error) {
            let params = {
              phone: this.areaPhone,
              typ: 'register',
            }
            this.$http
              .post('/api/accounts/send-sms/', params)
              .then(res => {
                this.notifyOpen('Success', this.$t('messages.register.codeSended'))
                this.handleCountdown()
                this.lunxunPhone = this.areaPhone
                this.handleCountdown2()
              })
              .catch(error => {
                if (error.c === -1301) {
                  this.notifyOpen('Error', this.$t('messages.register.codeAgain'), 'error')
                }else if (error.c === -1404) {
                  this.notifyOpen('Error', this.$t('messages.register.codeAgain2'), 'error')
                } else if (error.c === -1405) {
                  this.notifyOpen('Error', this.$t('messages.tipError.phoneCodeErr'), 'error')
                }else {
                  this.notifyOpen('Error', error.m || this.$t('messages.tipError.timeout'), 'error')
                }
              })
          }
        })
      }
    },
    handleDomain() {
      window.open('https://beian.miit.gov.cn', '_blank')
    },
    handleGo() {
      window.open(
        'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302003751',
        '_blank'
      )
    },
    setFormRules() {
      this.rules = {
        username: [
          {
            required: true,
            message: this.$t('messages.register.emptyErr'),
            trigger: ['blur', 'change'],
          },
          {
            validator: (rule, value, callback) => {
              // const reg = /[^a-zA-Z0-9\u4E00-\u9FA5]/
              var reg2 = new RegExp(
                '[`~!@#$^&*()=|{}:;,\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“。，、？]'
              )
              // const noEmptyReg = /^(?!(\s+$))/
              if (reg2.test(value)) {
                callback(new Error(this.$t('messages.register.nameErr')))
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        password: [{ validator: this.validatePass, trigger: ['blur', 'change'] }],
        confirm_password: [{ validator: this.validateConfirmPass, trigger: ['blur', 'change'] }],
        // captcha: [
        //   { required: true, message: this.$t('messages.register.emptyErr'), trigger: 'blur' },
        //   {
        //     validator: this.verifyCaptcha,
        //     trigger: ['blur'],
        //   },
        // ],
        email: [
          {
            required: true,
            message: this.$t('messages.register.emptyErr'),
            trigger: ['blur', 'change'],
          },
          {
            type: 'email',
            message: this.$t('messages.register.emailFormatErr'),
            trigger: ['blur', 'change'],
          },
        ],
        user_agreement: [
          {
            validator: this.verifyUserAgreement,
            trigger: ['change'],
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t('messages.register.phoneFormatErr'),
            trigger: ['blur'],
          },
          // {validator: this.validatePhone, trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regex = /\D/
              let phoneRegex = /^1[3-9]\d{9}$/ // 手机号正则表达式
              if (this.area !== 'CN') {
                if (regex.test(value)) {
                  return callback(new Error(this.$t('messages.register.phoneErr1')))
                } else if (value.length > 20) {
                  return callback(new Error(this.$t('messages.register.phoneErr3')))
                } else {
                  callback()
                }
              } else {
                if (!phoneRegex.test(value)) {
                  if (regex.test(value)) {
                    return callback(new Error(this.$t('messages.register.phoneErr1')))
                  } else {
                    return callback(new Error(this.$t('messages.register.phoneErr2')))
                  }
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: this.$t('messages.register.verificationCodeEmpty'),
            trigger: ['blur'],
          },
          {
            validator: (rule, value, callback) => {
              const regex = /^[0-9A-Za-z]{6}$/ // 手机号正则表达式
              if (!regex.test(value)) {
                callback(new Error(this.$t('messages.register.verificationCodeDigit')))
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      }
    },
    // changeLang() {
    //   let str = this.$i18n.locale
    //   if (str === 'zh') {
    //     this.$i18n.locale = 'en'
    //     this.$router.push({ path: '/en-us/login' })
    //   } else {
    //     this.$i18n.locale = 'zh'
    //     this.$router.push({ path: '/zh-cn/login' })
    //   }
    // },
    // goLogin(){
    //   let str = this.$i18n.locale
    //   if (str === 'zh') {
    //     this.$router.push({ path: '/zh-cn/login' })
    //   } else {
    //     this.$router.push({ path: '/en-us/login' })
    //   }
    // },
    changeContactType(value) {
      let path = this.applications.find(item => item.value === value).src
      if (this.$refs.contact_type) {
        this.$refs.contact_type.$el.children[0].setAttribute(
          'style',
          `background: url(${path}) no-repeat; background-size: 16px;background-position: 9px 16px;`
        )
      }
    },
    validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('messages.register.passErr')))
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[._0-9A-Za-z]{6,16}$/.test(value)) {
        callback(new Error(this.$t('messages.register.passRegErr')))
      } else {
        callback()
      }
    },
    validateConfirmPass(rule, value, callback) {
      if (value === '') {
        callback(new Error(this.$t('messages.register.passErr')))
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[._0-9A-Za-z]{6,16}$/.test(value)) {
        callback(new Error(this.$t('messages.register.passRegErr')))
      } else if (this.regist.password !== this.regist.confirm_password) {
        callback(new Error(this.$t('messages.register.passSameErr')))
      } else {
        callback()
      }
    },
    verifyCaptcha(rule, value, callback) {
      this.changeing = false
      var that = this
      setTimeout(function() {
        if (!that.changeing) {
          let params = {
            captcha: that.regist.captcha,
          }
          that.$http
            .post('/api/data/check-captcha/', params)
            .then(() => {
              callback()
            })
            .catch(error => {
              console.error(error)
              that.notifyOpen('Error', that.$t('messages.forget.codeErr'), 'error')
            })
        }
      }, 800)
    },
    verifyUserAgreement(rule, value, callback) {
      callback()
      // if (this.user_agreement.includes('1') && this.user_agreement.includes('2')) {
      //   callback()
      // } else {
      //   callback(new Error(this.$t('messages.tipError.ageErr')))
      // }
    },
    signUp() {
      this.$refs['registerForm'].validate(valid => {
        if (valid) {
          this.loading = true
          if (getCookie('csrftoken')) {
            removeCookie('csrftoken')
          }
          let { email, code, password, register_source, confirm_password } = this.regist
          let params = {
            register_source,
          }
          let postUrl = ''
          if (this.activeName === 'email') {
            params.email = email
            params.password = password
            params.confirm_password = confirm_password
            postUrl = '/api/accounts/register/'
          } else {
            params.phone = this.areaPhone
            params.code = code
            postUrl = '/api/accounts/register-phone/'
          }
          this.$http
            .post(postUrl, params)
            .then(() => {
              this.loading = false
              window.gtag('event', 'registerSuccess', { event_category: 'register' })
              window.lintrk('track', { conversion_id: 16222916 })
              this.routerChange('snapshot')
            })
            .catch(error => {
              this.loading = false
              if (error.c === -1053) {
                if (this.activeName === 'email') {
                  this.notifyOpen('Error', this.$t('messages.tipError.emailExit'), 'error')
                } else {
                  this.notifyOpen('Error', this.$t('messages.register.phoneExit'), 'error')
                }
              } else if (error.c === -1001) {
                // PswDiff
                this.notifyOpen('Error', this.$t('messages.forget.pswDiff'), 'error')
              } else if (error.c === -1121) {
                // EmailExists
                this.notifyOpen('Error', this.$t('messages.tipError.emailExists'), 'error')
              } else if (error.c === -1031) {
                this.notifyOpen('Error', this.$t('messages.forget.codeErr'), 'error')
              } else if (error.c === -1402) {
                this.notifyOpen('Error', this.$t('messages.tipError.phoneCodeFormatErr'), 'error')
              } else if (error.c === -1403) {
                this.notifyOpen('Error', this.$t('messages.tipError.internalErr'), 'error')
              } else if (error.c === -1404) {
                this.notifyOpen('Error', this.$t('messages.register.codeAgain2'), 'error')
              } else if (error.c === -1405) {
                this.notifyOpen('Error', this.$t('messages.tipError.phoneCodeErr'), 'error')
              }else if (error.c === -1) {
                this.notifyOpen('Error', this.$t('messages.tipError.invalidCodeErr'), 'error')
              } else {
                this.notifyOpen('Error', error.m || this.$t('messages.tipError.timeout'), 'error')
              }
            })
        }
      })
    },
    checkEmail() {
      let mailAddress = this.regist.email.split('@')[1]
      if (mailAddress) {
        if (mailAddress === 'gmail.com') {
          mailAddress = 'google.com'
        }
        window.open(`http://mail.${mailAddress}`, '_blank')
      }
    },
    sendEmailAgain() {
      let params = {
        email: this.regist.email,
        template: 'account_active',
      }
      this.$http
        .post('/api/accounts/email-send/', params)
        .then(res => {
          this.notifyOpen(this.$t('messages.createCampaign.create202'))
        })
        .catch(err => {
          switch (err.c) {
            case -1008: // EmailNotExists
              this.notifyOpen('Error', this.$t('messages.tipError.EmailNotExists'), 'error')
              break
            case -1007: // AlreadyVerify
              this.notifyOpen('Error', this.$t('messages.tipError.alreadyVerify'), 'error')
              break
            case -1006: // UnVerifyErr
              this.notifyOpen('Error', this.$t('messages.tipError.unVerifyErr'), 'error')
              break
            case -1121: // EmailExists
              this.notifyOpen('Error', this.$t('messages.tipError.emailExists'), 'error')
              break
            case -1038: // EmailCountLimit
              this.notifyOpen('Error', this.$t('messages.tipError.emailCountLimit'), 'error')
              break
            default:
              // Network error
              this.notifyOpen('Error', this.$t('messages.tipError.netErr'), 'error')
          }
        })
    },
    headerScroll() {
      this.$nextTick(() => {
        if (this.$refs.scrollbar) {
          let scrollEl = this.$refs.scrollbar.wrap
          scrollEl.onscroll = () => {
            if (scrollEl.scrollTop > 0) {
              this.hasScroll = true
            } else {
              this.hasScroll = false
            }
          }
        }
      })
    },
  },
  metaInfo() {
    // 当前路由和支持的语言
    const currentRoute = this.$route
    const supportedLangs = ['en', 'zh']
    const baseUrl = 'https://app.asogrow.net'
    // 获取当前路径并移除语言前缀
    const currentPath = currentRoute.path.replace(`/${currentRoute.params.lang}`, '') || '/'
    // 生成 hreflang 标签
    const hreflangLinks = supportedLangs.map(lang =>{
      let newLang = 'en-us';
      if(lang === 'zh'){
        newLang = 'zh-cn'
      }
      return {
        rel: 'alternate',
        hreflang: newLang,
        // href: `${baseUrl}/${lang}${currentRoute.path}`
        href: `${baseUrl}/${newLang}${currentPath}`
      }
    })

    // 添加 x-default 标签
    hreflangLinks.push({
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en-us${currentPath}`// currentRoute.path
    })

    return {
      title: this.$t('messages.register.metaTitle'),
      meta: [
        {
          name: 'description',
          content: this.$t('messages.register.metaDesc'),
          vmid: 'description',
        },
        {
          name: 'keywords',
          content: this.$t('messages.register.metaKeywords'),
          vmid: 'keywords'
        }
      ],
      link: hreflangLinks
    }

  }
}
</script>

<style lang="scss">
.el-notification__content {
  text-align: left;
}
.register {
  min-height: 100%;
  position: relative;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  .content {
    padding: 0;
    background-color: #fafcff;
    margin-bottom: 0px;
    position: relative;
    .login-banner {
      display: none;
    }
    .header {
      height: 40px;
      padding: 24px 40px 0 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      transition: all 0.4s ease;
      .logo {
        margin: 0 0 0 16px;
        .logo-img {
          width: 175px;
          height: auto;
        }
      }
      .rightWrap {
        display: flex;
        align-items: center;
        position: relative;
        .banner-logo {
          width: 272px;
          height: 152px;
          position: absolute;
          top: 48px;
          right: -8px;
          z-index: 2;
          display: none;
          > img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .langBtn {
        width: 82px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e9077c;
        font-size: 14px;
        color: #e9077c;
        font-weight: 400;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        cursor: pointer;
      }
      a {
        text-decoration: none;
        padding: 0;
      }
      .login-link {
        width: 80px;
        height: 32px;
        border-radius: 4px;
        background: #e30077;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }
    }
    .scroll {
      transition: padding 0.4s ease, margin-bottom 0.5s ease;
      padding: 8px 40px 8px 40px;
      box-shadow: 0px 4px 8px 0px rgba(33, 35, 41, 0.08);
      border: 1px solid rgba(235, 238, 245, 1);
      margin-bottom: 0;
    }
    .main {
      height: calc(100vh - 58px);
      .signup-title {
        display: flex;
        justify-content: space-between;
        color: #303133;
        margin-bottom: 24px;
        .signup-title-btn {
          display: none;
        }
        h1 {
          font-size: 38px;
          font-weight: 600;
          line-height: 46px;
          margin: 0;
        }
      }
      .regist-form {
        width: 464px;
        margin: 0 auto;
        padding-bottom: 40px;
      }
      .sign-up-btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: #e30077;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-style: none;
      }
      .sign-up-btn::before {
        background-color: rgba(255, 255, 255, 0.2);
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .copyright {
        text-align: center;
        // padding-bottom: 40px;
        line-height: 20px;
        > span {
          font-size: 13px;
          color: #c7cbd2;
          cursor: pointer;
          margin-right: 14px;
          &:first-child {
            cursor: inherit;
          }
          &:last-child {
            margin-right: 0;
          }
          &:nth-child(2):hover {
            text-decoration: underline;
          }
          &:last-child:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .contact-tip-wrap {
      display: flex;
      margin-top: -6px;
      margin-bottom: 22px;
      .tip-wrap-logo {
        color: #3399ff;
      }
      > p {
        color: #909399;
        font-size: 12px;
      }
    }
    .lang-switch-wrap {
      display: none;
    }
  }
  .el-form-item.is-error .el-input__inner {
    border-color: #f56c6c !important;
  }
  .el-form-item.is-error .el-input__validateIcon {
    color: #f56c6c !important;
  }
  .regist-form {
    .el-input__inner {
      height: 48px;
      font-size: 16px;
    }
  }
  .el-input-group__prepend {
    .el-input {
      width: 142px;
    }
  }
  .el-input-group__append {
    padding: 0;
  }
  .el-input__suffix {
    font-size: 16px;
  }
  .user-agreement {
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #606266;
    }
    .el-checkbox__inner {
      width: 16px;
      height: 16px;
      &::after {
        left: 5px;
        top: 2px;
      }
    }
  }
  .form-label {
    display: inline-block;
    color: #606266;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }
  .question {
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    color: #606266;
    font-weight: 400;
    margin-bottom: 8px;
  }
  .before-btn {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    color: #e30077;
    border: 2px solid #e30077;
    &:hover {
      background-color: #fff;
    }
  }
  .before-btn::before {
    background: #e30077;
  }
  .confirm-btn {
    width: 100%;
    height: 48px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background: #e30077;
    border: none;
  }
  .confirm-btn::before {
    background-color: rgba(255, 255, 255, 0.2);
  }
  .answer {
    box-sizing: border-box;
    width: 100%;
    padding: 12px 24px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #ffffff;
    margin-bottom: 8px;
    .el-radio-group {
      .el-radio {
        margin: 0 55px 0 0;
        display: inline-block;
        height: 32px;
        line-height: 32px;
      }
    }
    .el-checkbox {
      display: block;
      margin-right: 30px;
      margin-left: 0;
      height: 32px;
      line-height: 32px;
    }
    .el-select,
    .el-cascader {
      width: 50%;
    }
    .el-radio-group {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .application-number {
    .el-select {
      .el-input {
        background: url('../../assets/img/Teams.png') no-repeat;
        background-size: 16px;
        background-position: 9px 16px;
      }
      .el-input__inner {
        text-indent: 20px;
        border-color: transparent !important;
      }
      .el-input__icon.el-input__validateIcon {
        display: none;
        color: transparent !important;
      }
    }
  }
  .register-success {
    width: 370px;
    height: 542px;
    // background: #fff;
    border-radius: 8px;
    // border: 1px solid rgba(235, 238, 245, 1);
    margin: 80px auto 0;
    box-sizing: border-box;
    h2 {
      // text-align: center;
      font-size: 30px;
      color: #303133;
      width: 370px;
      i {
        color: #77b300;
        font-size: 24px;
      }
    }
    img {
      display: block;
      width: 240px;
      height: 160px;
      margin: 24px auto 24px;
    }
    .sub-tit {
      color: #303133;
      font-weight: 600;
      line-height: 30px;
      font-size: 18px;
    }
    .email {
      color: #1861f2;
      font-weight: 600;
      line-height: 30px;
      font-size: 18px;
    }
    .content {
      color: #606266;
      line-height: 30px;
      font-size: 18px;
      display: inline;
      &:last-child {
        margin-left: -4px;
      }
    }
    .check-btn {
      width: 100%;
      height: 40px;
      background: #e30077;
      border-radius: 4px;
      border: none;
      margin-bottom: 8px;
      font-weight: bold;
    }
    .check-btn::before {
      background-color: rgba(255, 255, 255, 0.2);
    }
    .no-received {
      display: block;
      width: 125px;
      margin: 0 auto;
      color: #1861f2;
      text-align: center;
    }
  }
  .no-mail {
    width: 464px;
    height: 378px;
    // background: #ffffff;
    border-radius: 8px;
    // border: 1px solid rgba(235, 238, 245, 1);
    margin: 150px auto 0;
    box-sizing: border-box;
    padding: 0 23px;
    h2 {
      // text-align: center;
      font-size: 30px;
      color: #303133;
      i {
        color: #ff9933;
        font-size: 24px;
        vertical-align: 2px;
        display: none;
      }
    }
    .sub-tit {
      color: #303133;
      font-weight: 600;
      line-height: 30px;
      font-size: 20px;
    }
    .content {
      color: #606266;
      line-height: 30px;
      margin-bottom: 24px;
      font-size: 16px;
      a {
        color: #1861f2;
        font-size: 16px;
      }
    }
    .skip {
      width: 100%;
    }
    .skip-btn {
      width: 100%;
      height: 40px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      border: none;
      border-radius: 4px;
      background: #1861f2;
    }
    .skip-btn::before {
      background-color: rgba(255, 255, 255, 0.2);
    }
    .email {
      color: #1861f2;
      font-weight: 600;
      line-height: 30px;
    }
  }
  .head-tabs {
    .el-tabs__header {
      margin-bottom: 25px;
    }
  }
  .application-number2 .el-select .el-input {
    background: inherit !important;
    .el-input__inner {
      padding-left: 0 !important;
    }
  }
  .captcha-send-code {
    .el-input-group__append {
      width: 98px;
      height: 48px;
      background: #e9077c;
      border-radius: 0px 4px 4px 0px;
      color: #ffffff;
      text-align: center;
      border: none;
      cursor: pointer;
    }
    .send-code {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      #sending {
        display: none;
      }
    }
  }
  .el-tabs__header {
    .el-tabs__active-bar {
      background-color: #e30077 !important;
    }
    .el-tabs__item.is-active {
      color: #e30077 !important;
    }
    .el-tabs__item:hover {
      color: #e30077 !important;
    }
  }
}

@media screen and (max-width: 901px) {
  .register {
    .content {
      .login-banner {
        // display: block;
        > img {
          width: 100%;
          min-height: 125px;
          height: 125px;
        }
      }
      .header {
        padding: 0.4267rem;
        padding-bottom: 0;
        margin-bottom: 0;
        .logo {
          margin-left: 0;
        }
        .rightWrap {
          .langBtn {
            display: none;
          }
        }
        .login-link {
          display: none;
        }
      }
      .main {
        .signup-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .signup-title-btn {
            display: flex;
            width: 80px;
            height: 32px;
            border-radius: 4px;
            background: #e30077;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-weight: 400;
            font-size: 16px;
          }
        }
        .regist-form {
          margin-top: 40px;
          .el-form-item {
            margin-bottom: 20px;
          }
          .captcha {
            .el-input__inner {
              width: 5.8667rem;
            }
            .el-input-group__append {
              width: 100%;
            }
          }
        }
        .register-success {
          margin-top: 40px;
        }
      }
      .lang-switch-wrap {
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 1.0667rem;
        margin-bottom: 1.0667rem;
        .lang-switch {
          width: 72px;
          height: 30px;
          border-radius: 15px;
          opacity: 1;
          border: 1px solid rgba(24, 97, 242, 0.3);
          display: flex;
          align-items: center;
          padding: 0 4px;
          .lang-icon {
            width: 50%;
            font-size: 14px;
            color: #1861f2;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .langActive {
            width: 35px;
            height: 22px;
            background: #1861f2;
            border-radius: 12px;
            color: #fff;
          }
        }
      }
      .banner-logo {
        display: none;
      }
    }
    .copyright3 {
      margin-top: 50px;
    }
    .copyright {
      // padding-bottom: 130px;
    }
  }
}

@media screen and (max-width: 701px) {
  .register {
    .content {
      .main {
        .copyright {
          > span {
            &:first-child {
              display: block;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .register {
    .content {
      .main {
        .regist-form {
          width: calc(100% - 0.8534rem);
        }
      }
    }
    .register-success {
      width: calc(100% - 0.8534rem);
      height: auto;
      margin-top: 0;
      h2 {
        margin-top: 0;
        font-size: 28px;
        width: auto;
      }
    }
    .no-mail {
      width: calc(100% - 0.8534rem);
      margin-top: 40px;
      height: auto;
      padding: 0;
      h2 {
        margin-top: 0;
      }
    }
    .copyright3 {
      margin-top: 30px !important;
      // padding-bottom: 60px !important;
    }
  }
}

@media screen and (max-width: 500px) {
  .register {
    .content {
      .main {
        .regist-form {
          // padding-bottom: 10px;
          .form-label {
            display: none;
          }
          .contact-tip-wrap {
            display: none;
          }
        }
      }
    }
    .user-agreement {
      .el-checkbox {
        white-space: normal;
        display: flex !important;
        align-items: center !important;
      }
      .el-checkbox__label {
        display: inline;
      }
    }
  }
}
</style>
